export default __webpack_public_path__ + "static/media/texp5.dd495beb.png";